import * as React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import "./portal.css";
import MenuIcon from '@mui/icons-material/Menu';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role=""
      hidden={value !== index}
      id={`-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function FullWidthTabs(props) {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {    

    setValue(index);
  };

  return (
    <Box className = 'tab-dev '>
      <AppBar position="" className='tab-cover'>
        <Tabs
          className='tabs'
          value={value}
          onChange={handleChange}
          indicatorColor=""
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <MenuIcon className='lg:mt-3 lg:ml-[2rem] relative lg:left-[6rem]'/>
          <Tab  label="Menu" onClick={props.toggleDrawer} {...a11yProps(0)} />
          <Tab label="Dashboard" onClick={props.showDashboard} {...a11yProps(1)} />
          <Tab label="Account Information" onClick={props.showAccountInfo} {...a11yProps(2)} />
          <Tab label="Invoices" onClick={props.showInvoices} {...a11yProps(3)} />
          <Tab label="Orders" onClick={props.showOrders} {...a11yProps(4)} />
          <Tab label="Quotes" onClick={props.showQuotes} {...a11yProps(5)} />
        </Tabs>
      </AppBar>
    </Box>
  );
}
